module.exports = "/_next/static/images/ramen-1440886dcfd76efb454d951bc13f92c8.jpg";